import { render, staticRenderFns } from "./crowdChange.vue?vue&type=template&id=a48509ec&"
import script from "./crowdChange.vue?vue&type=script&lang=js&"
export * from "./crowdChange.vue?vue&type=script&lang=js&"
import style0 from "./crowdChange.vue?vue&type=style&index=0&id=a48509ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports